


















































































































































































import {
  Component,
  Vue, Watch,
} from 'vue-property-decorator';
import SubscriptionsService from '@/services/subscriptions.service';
import Table from '@/components/Table.vue';
import {Action, Getter} from 'vuex-class';
import AccOrgAutocomplete from '@/components/AccOrgAutocomplete.vue';
import { debounce } from '@/classes/utils';
import {unparse} from 'papaparse';
import {saveAs} from 'file-saver';
import DeviceService from '@/services/device.service';
import EventBus from '@/services/eventbus.service';
import ActionBarButton from '@/components/ActionBarButton.vue';
import Transformation from '@/classes/transformation';

@Component({
  components: {
    ActionBarButton,
    Table,
    AccOrgAutocomplete,
  },
})
export default class Subscriptions extends Vue {
  @Action private clearToastErrorMessages: any;
  @Getter private hasPermission: any;

  private loading: boolean = true;
  private dataTableHeight: number = 100;
  private search: string = '';
  private expiresBetweenSelected: { text: string; value: { start: Date; end: Date } | boolean } | null = null;
  private dates: string[] = [];
  private menu: boolean = false;
  private accOrOrgSelected: {id: number; is_org: boolean} | null = null;
  private exclusion: string | null = null;

  private expiresBetweenItems: any[] = [
    { id: 1, text: 'In the next week', value: this.thisWeek },
    { id: 2, text: 'In the next 30 days', value: this.next30Days },
    { id: 3, text: 'This month', value: this.thisMonth },
    { id: 4, text: 'Next month', value: this.nextMonth },
    { id: 5, text: 'This calendar quarter', value: this.thisQuarter },
    { id: 6, text: 'Next calendar quarter', value: this.nextQuarter },
    { id: 7, text: 'Custom range', value: this.dates },
    { id: 8, text: 'Already expired', value: true },
  ];

  private delaySearchFilter = debounce((func: any) => {
    func();
  }, 750);

  private tableOptions: any = {};
  private externalFilters: any = {};

  private queryData: any = { sort: 'suborder.order_number' };
  private page: number = 1;
  private perPage: number = 100;
  private itemsPerPage: number = 100;
  private tableData: { headers: any[], rows: any[], total: number } = {
    rows: [],
    total: 0,
    headers: [
      {
        text: 'Subscription id',
        value: 'subscription_id',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Order reference',
        value: 'subscription_order',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'orderNumbers',
        querySortKey: 'order_number',
      },
      {
        text: 'Subscription product',
        value: 'subscription_product',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'subscriptionProducts',
        querySortKey: 'subscription_product',
      },
      {
        text: 'Product code',
        value: 'product_code',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'productCodes',
        querySortKey: 'product_code',
      },
      {
        text: 'Account',
        value: 'account',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'accounts',
        querySortKey: 'account',
      },
      {
        text: 'Organisation',
        value: 'organisation',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'organisations',
        querySortKey: 'organisation',
      },
      {
        text: 'Status',
        value: 'subscription_status',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'statuses',
        querySortKey: 'subscription_status',
        cellClass: 'text-capitalize',
        class: 'text-capitalize',
      },
      {
        text: 'Created on',
        value: 'subscription_created_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionCreatedAt',
        querySortKey: 'subscription_created_at',
      },
      {
        text: 'Activated on',
        value: 'subscription_activated_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionActivatedAt',
        querySortKey: 'subscription_activated_at',
      },
      {
        text: 'End of term',
        value: 'subscription_expires_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionExpiresAt',
        querySortKey: 'subscription_expires_at',
      },
      {
        text: 'Activate by',
        value: 'subscription_activate_by',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionActivateBy',
        querySortKey: 'subscription_activate_by',
      },
      {
        text: 'Project',
        value: 'project',
        align: 'start',
        filterable: false,
        sortable: true,
        queryKey: 'projects',
        querySortKey: 'project',
      },
      {
        text: 'Location',
        value: 'location',
        align: 'start',
        sortable: true,
        querySortKey: 'location',
      },
      {
        text: 'Site',
        value: 'site',
        align: 'start',
        sortable: true,
        querySortKey: 'site',
      },
      {
        text: 'Device id',
        value: 'device_id',
        align: 'start',
        sortable: true,
        querySortKey: 'device_id',
      },
      {
        text: 'Network id',
        value: 'network_id',
        align: 'start',
        sortable: true,
        querySortKey: 'network_id',
      },
      {
        text: 'Device type',
        value: 'device_type',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'deviceTypes',
        querySortKey: 'device_type',
      },
      {text: 'Device first deployed on', value: 'device_first_deployed_at', align: 'start', sortable: true},
      {
        text: 'Device deleted on',
        value: 'device_deleted_at',
        align: 'start',
        sortable: true,
        querySortKey: 'device_deleted_at',
      },
      {
        text: 'Device stage',
        value: 'device_stage',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'deviceStages',
        querySortKey: 'device_stage',
      },
      {
        text: 'SIM ICCID',
        value: 'sim_iccid',
        align: 'start',
        sortable: true,
        querySortKey: 'sim_iccid',
      },
      {
        text: 'Auto-renew',
        value: 'autoRenew',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'autoRenew',
        querySortKey: 'auto_renew',
      },
      {
        text: 'Messages in month',
        value: 'messages',
        align: 'start',
        sortable: true,
        querySortKey: 'messages',
      },
    ],
  };

  private async mounted() {
    if (this.$route.params.subscriptionOrderId) {
      this.externalFilters = {
        orderNumbers: [Number(this.$route.params.subscriptionOrderId)],
      };
    } else {
      await this.loadData();
    }
  }

  private async onQueryDataUpdate(data: any) {
    this.queryData = data;
    await this.loadData(data);
  }

  private async loadData(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        filters?: { [key: string]: any };
        timeFilters?: { [key: string]: Date[] }; } = this.queryData,
      search: string = this.search,
  ) {
    this.loading = true;
    if (this.accOrOrgSelected && this.accOrOrgSelected.id) {
      queryData.filters = queryData.filters || {};
      if (this.accOrOrgSelected.is_org) {
        queryData.filters.organisations = [];
        queryData.filters.organisations.push(this.accOrOrgSelected.id);
      } else {
        queryData.filters.accounts = [];
        queryData.filters.accounts.push(this.accOrOrgSelected.id);
      }
    }
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const mappedTimeFilters = Transformation.timeFiltersToMap(queryData.timeFilters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;
    try {
      const params: {
        organisationId?: number;
        accountId?: number;
        subscriptionOrderId?: number;
        projectId?: number;
        search?: string;
        expiresBetween?: { start: Date | string; end: Date | string };
        expired?: boolean;
        excludeExpired?: boolean;
        excludeLapsed?: boolean;
        excludeActive?: boolean;
        excludeNotRenewing?: boolean;
        excludeDetached?: boolean;
        excludeAvailable?: boolean;
      } = {
        subscriptionOrderId: undefined,
        excludeExpired: this.exclusion === 'expired' || this.exclusion === 'activeexpired',
        excludeNotRenewing: this.exclusion === 'not_renewing',
        excludeDetached: this.exclusion === 'detached',
        excludeAvailable: this.exclusion === 'available',
        excludeLapsed: this.exclusion === 'lapsed',
        excludeActive: this.exclusion === 'active' || this.exclusion === 'activeexpired',
      };
      if (this.search && this.search.trim().length) {
        params.search = this.search.trim();
      }
      if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value !== 'boolean') {
        params.expiresBetween = this.expiresBetweenSelected.value;
      } else if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value === 'boolean') {
        params.expired = this.expiresBetweenSelected.value;
      }
      const { items, total, columnFilters } = await SubscriptionsService.getAdminSubscriptions(
          take,
          queryData.skip,
          queryData.sort,
          queryData.desc,
          mappedFilters,
          mappedTimeFilters,
          params,
      );
      const formattedItems = items.map((item: any) => {
        item.autoRenew = item.auto_renew.charAt(0).toUpperCase() + item.auto_renew.slice(1);
        return item;
      });
      Vue.set(this.tableData, 'rows', formattedItems);
      Vue.set(this.tableData, 'total', total);
      Transformation.setTableFilterValues(this.tableData.headers, columnFilters);
    } finally {
      this.loading = false;
    }
  }

  private async exportCsv() {

    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(this.queryData.filters);
    const mappedTimeFilters = Transformation.timeFiltersToMap(this.queryData.timeFilters);
    const take = !this.queryData.take || this.queryData.take === 0 ? this.perPage : this.queryData.take;
    try {
      const params: {
        take: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        accountId?: number;
        organisationId?: number;
        searchString?: string;
        filters?: any;
        timeFilters?: any;
        excludeExpired?: boolean;
        excludeLapsed?: boolean;
        excludeActive?: boolean;
        excludeNotRenewing?: boolean;
        excludeDetached?: boolean;
        excludeAvailable?: boolean;
        subscriptionOrderId?: number;
        sortParams?: {
          take?: number;
          skip?: number;
          sort?: string;
          desc?: boolean;
        };
      } = {
        subscriptionOrderId: undefined,
        excludeExpired: this.exclusion === 'expired' || this.exclusion === 'activeexpired',
        excludeNotRenewing: this.exclusion === 'not_renewing',
        excludeDetached: this.exclusion === 'detached',
        excludeAvailable: this.exclusion === 'available',
        excludeLapsed: this.exclusion === 'lapsed',
        excludeActive: this.exclusion === 'active' || this.exclusion === 'activeexpired',
        take: this.queryData.itemsPerPage,
      };
      params.sortParams = {};
      if (this.queryData.page > 1) {
        params.sortParams.skip = this.queryData.itemsPerPage * (this.queryData.page - 1);
      }
      if (this.queryData.sort) {
        params.sortParams.sort = this.queryData.sort;
        params.sortParams.desc = !!this.queryData.desc;
      }
      if (this.search && this.search.trim().length) {
        params.searchString = this.search.trim();
      }

      function convertToArray(inputObject: any) {
        const outputObject: any = {};

        for (const outerKey in inputObject) {
          if (inputObject.hasOwnProperty(outerKey)) {
            outputObject[outerKey] = [];
            for (const innerKey in inputObject[outerKey]) {
              if (inputObject[outerKey][innerKey]) {
                outputObject[outerKey].push(innerKey);
              }
            }
          }
        }

        return outputObject;
      }
      function convertDatesToArrays(inputObject: any) {
        const outputObject: any = {};

        for (const key in inputObject) {
          if (inputObject.hasOwnProperty(key)) {
            outputObject[key] = [];
            if (inputObject[key] && typeof inputObject[key] === 'object') {
              if (inputObject[key].start) {
                outputObject[key].push(
                    new Date(inputObject[key].start).getTime(),
                );
              }
              if (inputObject[key].end) {
                outputObject[key].push(
                    new Date(inputObject[key].end).getTime(),
                );
              }
            }
            if (outputObject[key].length === 0) {
              delete outputObject[key];
            }
          }
        }
        return outputObject;
      }

      params.filters = {...convertToArray(mappedFilters), ...convertDatesToArrays(mappedTimeFilters)};

      const {job_id} = await SubscriptionsService.adminExport(params);
      EventBus.$emit('adminJobCreated', job_id, true);
    } finally {
      this.loading = false;
    }
  }

/*  private async exportCsv() {
    try {
      const params: {
        accountId?: number;
        organisationId?: number;
        searchString?: string;
        expiresBetween?: { start: Date | string; end: Date | string};
        expired?: boolean;
        excludeExpired?: boolean;
        excludeInactive?: boolean;
        excludeActive?: boolean;
        sortParams: {
          take: number;
          skip: number;
          useLimitOffset?: boolean;
          order?: {
            [k: string]: 'DESC' | 'ASC',
          };
        }
      } = {
        excludeExpired: (this.exclusion !== null && this.exclusion !== 'active'),
        excludeInactive: this.exclusion === 'inactive',
        excludeActive: (this.exclusion !== null && this.exclusion.startsWith('active')),
        sortParams: {
          take: 50000,
          skip: 0,
        },
      };
      if (this.tableOptions.page > 1) {
        params.sortParams.skip = this.tableOptions.itemsPerPage * (this.tableOptions.page - 1);
      }
      if (this.tableOptions.sortBy.length) {
        params.sortParams.order = { [this.tableOptions.sortBy[0]]: this.tableOptions.sortDesc[0] ? 'DESC' : 'ASC' };
      }
      if (this.search && this.search.trim().length) {
        params.searchString = this.search.trim();
      }
      if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value !== 'boolean') {
        params.expiresBetween = this.expiresBetweenSelected.value;
      } else if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value === 'boolean') {
        params.expired = this.expiresBetweenSelected.value;
      }
      if (this.accOrOrgSelected && this.accOrOrgSelected.id) {
        if (this.accOrOrgSelected.is_org) {
          params.organisationId = this.accOrOrgSelected.id;
        } else {
          params.accountId = this.accOrOrgSelected.id;
        }
      }
      const {job_id} = await SubscriptionsService.adminExport(params);
      EventBus.$emit('adminJobCreated', job_id, true);
    } finally {
      this.loading = false;
    }
  }*/

  private selectExpiresBetween(item: {text: string; value: any}) {
    const custom = this.expiresBetweenItems.find((i) => i.id === 7);
    custom.text = 'Custom range';
    custom.value = { start: undefined, end: undefined };
    if (item && item.text.toLowerCase().includes('custom')) {
      this.menu = true;
    } else {
      this.loadData();
    }
  }

  private saveDates() {
    const custom = this.expiresBetweenItems.find((i) => i.id === 7);
    custom.text = this.dates.join(' - ');
    custom.value = { start: this.dates[0], end: this.dates[1] };
    this.expiresBetweenSelected = custom;
    this.menu = false;
    this.loadData();
  }
  private get thisWeek() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();
    const start = new Date(y, m, d);
    const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 7);
    return { start, end };
  }

  private get next30Days() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();
    const start = new Date(y, m, d);
    const end = new Date(y, m, d + 30);
    return { start, end };
  }

  private get thisMonth() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const start = new Date(y, m, 1);
    const end = new Date(y, m + 1, 0);
    return { start, end };
  }

  private get nextMonth() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const start = new Date(y, m, 1);
    const end = new Date(y, m + 1, 0);
    return { start, end };
  }

  private get thisQuarter() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const quarter = Math.floor((m / 3));
    const start = new Date(y, quarter * 3, 1);
    const end = new Date(y, start.getMonth() + 3, 0);
    return { start, end };
  }
  private get nextQuarter() {
    const date = new Date();
    let y = date.getFullYear();
    const m = date.getMonth() + 3;
    const quarter = Math.floor((m / 3));
    let start: Date;
    let end: Date;
    if (quarter === 4) {
      ++y;
      start = new Date(y, 0, 1);
      end = new Date(y, start.getMonth() + 3, 0);
      return { start, end };
    }
    start = new Date(y, quarter * 3, 1);
    end = new Date(y, start.getMonth() + 3, 0);
    return { start, end };
  }

  @Watch('accOrOrgSelected')
  private async onAccOrOrgSelected() {
    if (!this.accOrOrgSelected) {
      this.queryData.filters = {};
    }
    await this.loadData();
  }

  @Watch('search')
  private onSearch() {
    this.delaySearchFilter(this.loadData);
  }

  @Watch('tableOptions', { deep: true })
  private async onTableOptionsChanged() {
    await this.loadData();
  }

  @Watch('excludeExpired')
  private async onExcludeExpiredChanged() {
    await this.loadData();
  }

  @Watch('exclusion')
  private async onExcludeInactiveChanged() {
    await this.loadData();
  }

}
